import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { FlamePage } from './pages/FlamePage.js';
import { HomePage } from './pages/HomePage.js';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/flame/:uuid" element={<FlamePage />} />
      </Routes>
    </BrowserRouter>
  );
}
